import styled from '@emotion/styled'

import { ApiStrategyTemplate } from '../../../api/_legacy/generated-api'
import { Space } from '../../../components/core-v2'
import StrategiesView from '../templates/strategies-view'

export type StrategiesPanelProps = {
  onSelectStrategy?: (strategyTemplateId: string) => void
  selectedStrategy?: ApiStrategyTemplate
  strategies: ApiStrategyTemplate[]
}

const StyledStrategyList = styled.div`
  height: calc(100vh - 119px);
  overflow-y: auto;
`

export const StrategiesPanel = ({
  onSelectStrategy,
  selectedStrategy,
  strategies
}: StrategiesPanelProps) => (
  <StyledStrategyList>
    <Space isflex flexDirection="column">
      <Space mt={6}>
        <StrategiesView
          selectedStrategy={selectedStrategy}
          strategies={strategies}
          onSelectStrategy={onSelectStrategy}
        />
      </Space>
    </Space>
  </StyledStrategyList>
)
